<div class="bary-table-list py-4 table-responsive">
  <table mdbTable [hover]="true" [small]="true">
    <thead>
      <tr class="tr-align-center grey-text">
        <th colspan="4" class="tab-title text-center">{{ 'LABEL.PICKUP_DELIVERY' | translate }}</th>
        <th colspan="3" class="tab-title text-center">{{ 'LABEL.MERCHANDISES' | translate }}</th>
        <th colspan="3" class="tab-title text-center">{{ 'LABEL.INFORMATIONS' | translate }}</th>
      </tr>
      <tr [(ascending)]="pagination.reverse" [(predicate)]="pagination.predicate" (sortChange)="transition()" jhiSort>
        <th class="p-1">
          <span jhiTranslate="unvalidatedBaskets.list.head.creationDate"></span>
        </th>
        <th class="p-1">
          <span jhiTranslate="baryApp.customer.companyName"></span>
        </th>
        <th class="text-center p-1">
          <span jhiTranslate="LABEL.PICKUP_DATE">Pickup Date</span><br />
          <span jhiTranslate="LABEL.DELIVERY_DATE">Delivery Date</span>
        </th>
        <th class="p-1">
          <span jhiTranslate="LABEL.PICKUP_LOCATION"></span><br />
          <span jhiTranslate="LABEL.DELIVERY_LOCATION"></span>
        </th>
        <th jhiSortBy="totalUM" class="text-center p-1">
          <span jhiTranslate="LABEL.UM" class="no-capitalize"></span>
        </th>
        <th jhiSortBy="totalWeight" class="text-center p-1">
          <span jhiTranslate="LABEL.WEIGHT"></span>
          <fa-icon icon="sort"></fa-icon>
        </th>
        <th class="text-center p-1">
          <span jhiTranslate="LABEL.PRE_TAXES_PRICE" class="no-capitalize"></span>
        </th>
        <th class="text-center p-1">
          <span jhiTranslate="LABEL.STATUS"></span>
        </th>
        <th class="text-center p-1">
          <span jhiTranslate="unvalidatedBaskets.list.head.events"></span>
        </th>
        <th></th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let transport of transportsPending">
        <td class="p-1">{{ transport.creationDate?.toDate() | date: 'dd/MM/yyyy' }}</td>
        <td class="text-left p-1">
          <a *ngIf="transport.customerId" [href]="PATHS.MIDDLE_CUSTOMER_ID_DATA.withId(transport.customerId)" target="_blank">
            <ng-container *ngIf="transport.user?.companyName">
              {{ transport.user?.companyName }}
            </ng-container>
            <ng-container *ngIf="!transport.user?.companyName && transport.pickupAddressFullname">
              {{ transport.pickupAddressFullname }}
            </ng-container>
            <ng-container *ngIf="!transport.pickupAddressFullname"> {{ transport?.user?.firstName }} {{ transport?.user?.lastName }} </ng-container>
            <ng-container *ngIf="!transport.pickupAddressFullname && !transport.user"> Inconnu</ng-container>
          </a>
          <span *ngIf="!transport.customerId">
            <ng-container *ngIf="transport.pickupAddressFullname"> {{ transport.pickupAddressFullname }} </ng-container>
            <ng-container *ngIf="!transport.pickupAddressFullname"> {{ transport?.user?.firstName }} {{ transport?.user?.lastName }} </ng-container>
            <ng-container *ngIf="!transport.pickupAddressFullname && !transport.user"> Inconnu </ng-container>
          </span>
        </td>
        <td class="text-center p-1">
          {{ transport.pickupDate?.toDate() | date: 'dd/MM/yyyy' }} <br />
          {{ transport.deliveryDate?.toDate() | date: 'dd/MM/yyyy' }}
        </td>
        <td class="text-left p-1">
          <span class="no-capitalize"
            >{{ transport.pickupAddressCity ? transport.pickupAddressCity : '' }}, {{ transport.pickupAddressZipCode ? transport.pickupAddressZipCode : '' }},
            {{ transport.pickupAddressCountry | countryName }}</span
          ><br />
          <span class="no-capitalize"
            >{{ transport.deliveryAddressCity ? transport.deliveryAddressCity : '' }}, {{ transport.deliveryAddressZipCode ? transport.deliveryAddressZipCode : '' }},
            {{ transport.deliveryAddressCountry | countryName }}</span
          >
        </td>
        <td class="text-center p-1">
          <span [mdbTooltip]="getTotalUMTooltip(transport)">{{ totalUM(transport) }}</span>
        </td>
        <td class="text-center p-1">
          <span>{{ transport.totalWeight }}&nbsp;kg</span>
        </td>
        <td class="text-center p-1">
          <span *ngIf="transport.quotationPriceHT" class="no-capitalize">{{ transport.quotationPriceHT | currency: 'EUR' }}</span>
          <span *ngIf="!transport.quotationPriceHT && transport.goodsValue" class="no-capitalize">{{ transport.goodsValue | currency: 'EUR' }}</span>
        </td>
        <td class="text-center p-1">
          <mdb-badge
            [pill]="true"
            [danger]="true"
            *ngIf="transport.isOrphan"
            [mdbTooltip]="'baryApp.quotationStatus.tooltip.moderator.ORPHAN'"
            jhiTranslate="{{ 'baryApp.quotationStatus.moderator.ORPHAN' }}"
          >
          </mdb-badge>
          <mdb-badge
            [pill]="true"
            [warning]="true"
            *ngIf="!transport.isOrphan"
            [mdbTooltip]="'baryApp.quotationStatus.tooltip.moderator.' + transport.quotationStatus | translate"
            jhiTranslate="{{ 'baryApp.quotationStatus.moderator.' + transport.quotationStatus }}"
          >
            {{ transport.quotationStatus }}
          </mdb-badge>
        </td>
        <td class="text-center p-1">
          <ng-container *ngIf="(transport?.salesSupportActionsList || []).length > 0">
            <div
              *ngFor="let salesSupportAction of transport.salesSupportActionsList?.reverse() | slice: 0:1"
              jhiTranslate="{{ 'unvalidatedBaskets.error-shorty.' + salesSupportAction.typeSalesSupportActionsEnum }}"
              [translateValues]="{ date: getObjectFromJson(salesSupportAction.value).date, commercialFullName: getObjectFromJson(salesSupportAction.value).commercialFullName }"
            ></div>
            <span
              data-id-cypress="event-history"
              class="my-2 text-primary"
              *ngIf="(transport?.salesSupportActionsList || []).length > 1"
              (click)="displayMoreEvent(transport.salesSupportActionsList!)"
              >Afficher plus</span
            >
          </ng-container>
        </td>
        <td class="p-1">
          <jhi-bary-cta [actions]="getCta(transport)" (selectAction)="onSelectAction($event, transport)"></jhi-bary-cta>
        </td>
      </tr>
      <tr *ngIf="transportsPending.length === 0" class="text-center">
        <td colspan="9" class="table-data-not-found">
          <div class="text-center">
            <p class="lead p-5" data-id-cypress="merchandise-no-data" jhiTranslate="merchandises.list.noData"></p>
          </div>
        </td>
      </tr>
    </tbody>
  </table>
</div>
